(function () {
  'use strict';
  const instances = window.__lynkPresentationV28 || new WeakMap();
  window.__lynkPresentationV28 = instances;
  function initialize(root) {
    if (instances.has(root)) return;
    let resize = null;
    const controller = new AbortController();
    instances.set(root, {destroy() {resize?.disconnect(); controller.abort(); instances.delete(root);}});
    const toolbar = root.querySelector('[data-journey-toolbar]');
    if (toolbar) {
      const measure = () => root.style.setProperty('--lc-toolbar-height', toolbar.getBoundingClientRect().height + 'px');
      measure();
      if ('ResizeObserver' in window) {resize = new ResizeObserver(measure); resize.observe(toolbar);}
    }
    const finder = root.querySelector('[data-gift-finder]');
    const copy = root.querySelector('[data-finder-presentation-copy]');
    if (!finder || !copy) return;
    const interpolate = (text, values) => Object.entries(values).reduce((value, [key, replacement]) => value.replaceAll('{' + key + '}', String(replacement)), text || '');
    function update(state) {
      if (!state?.format || !state.feeling) return;
      const data = root.lynkChristmasApi?.data;
      if (!data) return;
      const scent = data.scents[data.feelings[state.feeling]?.scent];
      if (!scent) return;
      const defaults = {calm: ['White Tea', 'Bergamot + jasmine'], welcome: ['Firlight Noël', 'Fir + amber'], cosy: ['Christmas Eve Latte', 'Lavender + tonka']};
      const expected = defaults[state.feeling];
      const exact = expected && scent.name === expected[0] && scent.notes === expected[1];
      const reason = exact ? copy.dataset[state.feeling + 'Reason'] : interpolate(copy.dataset.customReason, {feeling: scent.mood, name: scent.name, notes: scent.notes});
      const reasonNode = finder.querySelector('[data-finder-result-reason]');
      if (reasonNode) reasonNode.textContent = reason;
      const target = finder.querySelector('[data-finder-result-art]');
      const template = root.querySelector('template[data-finder-art="' + state.format + '"]');
      if (!target || !template) return;
      if (target.dataset.format !== state.format) {
        target.replaceChildren(template.content.cloneNode(true));
        target.dataset.format = state.format;
      }
      const caption = target.querySelector('figcaption');
      const originalCaption = template.content.querySelector('figcaption')?.textContent || '';
      caption.textContent = originalCaption ? originalCaption + ' ' + interpolate(copy.dataset.selectedImage, {name: scent.name}) : '';
      caption.hidden = !caption.textContent;
      target.hidden = false;
    }
    finder.addEventListener('lynk:gift-finder-stage', event => update(event.detail), {signal: controller.signal});
    update(finder.lynkGiftFinderApi?.getState());
  }
  function scan(scope) {
    if (scope.matches?.('[data-lynk-christmas]')) initialize(scope);
    scope.querySelectorAll?.('[data-lynk-christmas]').forEach(initialize);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll?.('[data-lynk-christmas]').forEach(root => instances.get(root)?.destroy());
    if (event.target.matches?.('[data-lynk-christmas]')) instances.get(event.target)?.destroy();
  });
}());
